function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 256,
  fill: "#eab14d",
  r: 256
}), /*#__PURE__*/React.createElement("path", {
  d: "m256 0c-4.57 0-9.111.125-13.622.361 135.052 7.082 242.379 118.824 242.379 255.639s-107.327 248.557-242.379 255.639c4.511.236 9.052.361 13.622.361 141.385 0 256-114.615 256-256s-114.615-256-256-256z",
  fill: "#e49542"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 256,
  fill: "#f4fbff",
  r: 199.487
}), /*#__PURE__*/React.createElement("path", {
  d: "m256 56.513c-5.525 0-10.994.235-16.405.675 102.499 8.344 183.083 94.163 183.083 198.812s-80.584 190.467-183.083 198.812c5.411.441 10.88.676 16.405.676 110.174 0 199.487-89.314 199.487-199.487s-89.313-199.488-199.487-199.488z",
  fill: "#daf1f4"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m256 117.911c-4.267 0-7.726-3.459-7.726-7.726v-11.34c0-4.267 3.459-7.726 7.726-7.726s7.727 3.459 7.727 7.726v11.34c0 4.267-3.46 7.726-7.727 7.726z",
  fill: "#2b4d66"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m358.687 160.794c-1.978 0-3.955-.755-5.464-2.263-3.017-3.018-3.017-7.909.001-10.927l8.019-8.018c3.017-3.018 7.909-3.017 10.927 0 3.017 3.018 3.017 7.909-.001 10.927l-8.019 8.019c-1.509 1.507-3.486 2.262-5.463 2.262z",
  fill: "#2b4d66"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m412.315 263.727h-11.34c-4.268 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h11.34c4.268 0 7.726 3.459 7.726 7.726s-3.459 7.726-7.726 7.726z",
  fill: "#2b4d66"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m366.11 374.433c-1.977 0-3.955-.755-5.464-2.263l-8.018-8.018c-3.017-3.018-3.017-7.909 0-10.928 3.018-3.016 7.909-3.016 10.928 0l8.018 8.018c3.017 3.018 3.017 7.909 0 10.928-1.509 1.508-3.487 2.263-5.464 2.263z",
  fill: "#2b4d66"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m255.158 420.043c-4.267 0-7.726-3.459-7.726-7.726v-11.34c0-4.268 3.459-7.726 7.726-7.726s7.726 3.459 7.726 7.726v11.34c0 4.267-3.459 7.726-7.726 7.726z",
  fill: "#2b4d66"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m144.452 373.837c-1.977 0-3.955-.755-5.463-2.264-3.018-3.017-3.017-7.909 0-10.927l8.019-8.018c3.018-3.016 7.909-3.017 10.927.001 3.017 3.017 3.017 7.909-.001 10.927l-8.019 8.018c-1.508 1.509-3.486 2.263-5.463 2.263z",
  fill: "#2b4d66"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m110.183 262.886h-11.34c-4.267 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h11.34c4.267 0 7.726 3.459 7.726 7.726.001 4.267-3.459 7.726-7.726 7.726z",
  fill: "#2b4d66"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m153.067 160.199c-1.977 0-3.954-.754-5.463-2.263l-8.019-8.018c-3.017-3.018-3.018-7.909-.001-10.927 3.018-3.017 7.909-3.018 10.927-.001l8.019 8.019c3.017 3.017 3.018 7.909.001 10.927-1.51 1.508-3.487 2.263-5.464 2.263z",
  fill: "#2b4d66"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m256 263.727h-65.62c-4.267 0-7.726-3.46-7.726-7.727s3.459-7.726 7.726-7.726h57.893v-98.297c0-4.267 3.459-7.726 7.726-7.726s7.726 3.459 7.726 7.726v106.023c.001 4.267-3.458 7.727-7.725 7.727z",
  fill: "#2b4d66"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m335.266 304.491c-1.19 0-2.396-.276-3.527-.857l-79.272-40.764c-3.795-1.951-5.289-6.609-3.338-10.404s6.609-5.29 10.405-3.338l79.272 40.763c3.795 1.952 5.29 6.61 3.338 10.404-1.371 2.665-4.075 4.196-6.878 4.196z",
  fill: "#da4a54"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 256,
  fill: "#365e7d",
  r: 20.622
}));

var SvgPreparing = function SvgPreparing(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPreparing, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/preparing.86c33316.svg";
export { ForwardRef as ReactComponent };